import {React, useState, useEffect} from 'react';
import axios from 'axios';
import {Grid, TextField, Box, Button, Paper,  Stack, FormControl,FormControlLabel,Checkbox,Typography} from '@mui/material';
import {CalendarMonth, RestartAlt, ArrowForwardIos} from '@mui/icons-material';
import * as employeeService from '../../services/employeeService';
import '../../App.css'
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';

// Custom component for required field label
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px' }}>*</span>
  </span>
);

const options = employeeService.getDepartmentCollection();

const initialFValues={
  id: 0,
  leaveType: '',
  isPaidLeave: false,
  isCarryForwardAllowed: false,
  isLeaveEncashmentAllowed: false,
  basisOfEncashment: '1',
  leaveYearFrom: new Date().toISOString().split('T')[0],
  leaveYearTo: new Date().toISOString().split('T')[0],
  isPre_SufAllowed: false,
  entitledDays: '1',
  rate: '1',
  maxAllowedOccasions: '1',
  perDuration: '2',
  maxDaysPerOccasion: '1',
  softwareStartDate: new Date().toISOString().split('T')[0]

}

function LeaveMasterForm(props){
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [checked, setChecked] = useState(false);
  const [selectedDate, setSelectedDate] =  useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validate = () => {
    let temp = {}
    temp.leaveType = values.leaveType ? "" : "This field is required."
    // temp.entitledDays = values.entitledDays ? "" : "This field is required."
    // temp.maxAllowedOccasions = values.maxAllowedOccasions ? "" : "This field is required."
    // temp.maxDaysPerOccasion = values.maxDaysPerOccasion ? "" : "This field is required."
    // temp.basisOfEncashment = values.basisOfEncashment.length != 0 ? "" : "This field is required."
    // temp.perDuration = values.perDuration.length != 0 ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }


  // console.log("Date:", selectedDate);
  // const classes = useStyle();

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    });

    if (errors[name]) {
      setErrors({
          ...errors,
          [name]: ''
      });
  }
}

  function handleChecked(e){
    setChecked(!checked);
  }

  useEffect(() => {
    async function getLeaveTypes(){
      if(props.fetch_id != 9999) {
        try {
          const leaveTypes =  await axios.get("`${process.env.REACT_APP_API_BASE_URL}/company-master/leave-master/get/" + props.fetch_id);
          setLeaveTypes(leaveTypes.data[0]);

          const editFValues = {
            id: leaveTypes.data[0].leave_type_id,
            leaveType: leaveTypes.data[0].leave_type,
            isPaidLeave: leaveTypes.data[0].paid_unpaid,
            isCarryForwardAllowed: leaveTypes.data[0].cary_forward,
            isLeaveEncashmentAllowed: leaveTypes.data[0].leave_encashable,
            basisOfEncashment: leaveTypes.data[0].encash_basedOn,
            leaveYearFrom: leaveTypes.data[0].leave_year_from.split('T')[0],
            leaveYearTo: leaveTypes.data[0].leave_year_to.split('T')[0],
            isPre_SufAllowed: leaveTypes.data[0].prefix_suffix,
            entitledDays: leaveTypes.data[0].entitled_days,
            maxAllowedOccasions: leaveTypes.data[0].max_occasions,
            perDuration: leaveTypes.data[0].entitled_days_duration,
            maxDaysPerOccasion: leaveTypes.data[0].max_days,
            softwareStartDate: leaveTypes.data[0].leave_calculate_from.split('T')[0],

          }
          setValues(editFValues);


        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
      } else {
        setValues(initialFValues);
      }
      }
    getLeaveTypes();
  },[]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()){
      let API_URL = '';
      if(props.fetch_id === 9999){
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/leave-master/add`;
      }else {
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/leave-master/edit/` + props.fetch_id;
      }
      axios.post(API_URL, values)
      .then(function (response) {
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: 'success'
          });
          dispatch(updateTableActions.startUpdateLeaveMaster());
        }
      })
      .catch(function (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      });
    }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "-15px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "700px", marginTop: "-20px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Setup Leaves</Typography> </Grid>
          <Grid item> <CalendarMonth style={{marginLeft: "-30px"}}  sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={4} sx={{margin: "30px"}} >

          <Stack className="form-input-row" direction="row" style={{marginLeft: "-21px"}} alignItems="center">
                <TextField
                  variant="outlined"
                  name="leaveType"
                  label={<RequiredLabel label="Leave Type" />}
                  size="small"
                  value={values.leaveType}
                  onChange={handleInputChange}
                  {...(errors.leaveType && {error:true, helperText: errors.leaveType} )}
                />

                <FormControl sx={{flexDirection: 'row', alignItems: 'center'}}>
                  <FormControlLabel
                    control={<Checkbox
                            name="isPaidLeave"
                            color="primary"
                            size="small"
                            checked={values.isPaidLeave}
                            onChange={ e => handleInputChange(convertToDefEventPara("isPaidLeave", e.target.checked))}
                            />}
                            label="Paid Leave"
                            sx={{marginRight: 2}}
                            />
                </FormControl>

                <FormControl sx={{flexDirection: 'row', alignItems: 'center'}}>
                <FormControlLabel
                  control={<Checkbox
                          name="isCarryForwardAllowed"
                          color="primary"
                          size="small"
                          checked={values.isCarryForwardAllowed}
                          onChange={ e => handleInputChange(convertToDefEventPara("isCarryForwardAllowed", e.target.checked))}
                          />}
                          label="Allow Carry Forward"
                          sx={{marginRight: 2}}
                          />
              </FormControl>
            </Stack>

           <Stack className="flex-start" style={{marginLeft:"5px"}} direction="row" spacing={5}>
                <TextField
                  variant="outlined"
                  className="date-picker"
                  type="date"
                  id="date-picker"
                  label="Leave Year From"
                  size="small"
                  name="leaveYearFrom"
                  defaultValue="2017-05-24"
                  value={values.leaveYearFrom}
                  onChange={handleInputChange}
                />
                <TextField
                  variant="outlined"
                  className="date-picker"
                  type="date"
                  id="date-picker"
                  label="Leave Year To"
                  size="small"
                  name="leaveYearTo"
                  defaultValue="2017-05-24"
                  value={values.leaveYearTo}
                  onChange={handleInputChange}
                />
            </Stack>

            <Grid container className="space-around">
              <Grid item>
              <Button className="form-btn" variant="contained" color="error" onClick={resetForm} endIcon={<RestartAlt />} >Reset</Button>
              </Grid>
              <Grid item>
              <Button className="form-btn" variant="contained" type="submit" endIcon={<ArrowForwardIos sx={{width: "18px", height: "18px"}} />} >Submit</Button>
              </Grid>
            </Grid>

            </Stack>
        </form>

      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
    </Box>
  )
}

export default LeaveMasterForm;
